import Services from "lib/Services";
import ajaxHelper from "data/util/ajaxHelper";
import LockActions from "data/LockActions";

const AUTO_RETRY_DELAY = 10 * 1000;

let lockClientId;

const promiseClientId = () =>
    lockClientId != null
        ? Promise.resolve(lockClientId)
        : Services.createLockClient()
            .then(info =>
                lockClientId = info.id);

const withAutoRetry = work =>
    work().catch(error => {
        if (error && error.hasOwnProperty("status") && error.status >= 500) {
            // server error; try again in a sec
            return new Promise(resolve =>
                // eslint-disable-next-line no-settimeout
                setTimeout(
                    () => resolve(work()),
                    AUTO_RETRY_DELAY
                ));
        }
        return Promise.reject(error);
    });

const idFromLockSetOrId = lockSetOrId =>
    typeof lockSetOrId === "number"
        ? lockSetOrId
        : lockSetOrId.id;

const LockApi = {

    createLockSet: lockSet =>
        ajaxHelper(
            promiseClientId().then(clientId =>
                withAutoRetry(() =>
                    Services.createLockSet(clientId, {locks: lockSet.locks}))
            ),
            {
                type: LockActions.LOCKSET_CREATED,
                id: lockSet.id,
            },
            {
                type: LockActions.LOCKSET_CREATE_ERROR,
                id: lockSet.id,
            },
        ),

    confirmLockset: lockSetOrId => {
        const id = idFromLockSetOrId(lockSetOrId);
        if (id == null) return;
        return ajaxHelper(
            promiseClientId().then(clientId =>
                Services.confirmLockSet(clientId, id)),
            {
                type: LockActions.LOCKSET_CONFIRMED,
                id,
            },
            {
                type: LockActions.LOCKSET_CONFIRM_ERROR,
                id,
            },
        );
    },

    releaseLockset: lockSetOrId => {
        const id = idFromLockSetOrId(lockSetOrId);
        if (id == null) return;
        return ajaxHelper(
            promiseClientId().then(clientId =>
                withAutoRetry(() =>
                    Services.releaseLockSet(clientId, id))),
            {
                type: LockActions.LOCKSET_RELEASED,
                id,
            },
            {
                type: LockActions.LOCKSET_RELEASE_ERROR,
                id,
            },
        );
    },

    releaseClient() {
        if (lockClientId == null) return;
        Services.deleteLockClient(lockClientId);
    },
};

export default LockApi;



// WEBPACK FOOTER //
// ./app/data/LockApi.js